import { useMemo, useState } from 'react'
import * as UserHttp from '../../services/api/https/settings/user.http'
import { errorHandler } from '../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  REGISTERING: 'Cadastrando novo usuário',
  SUCCESS: 'Sucesso',
}

const INITIAL_STATE = {
  formFields: {
    name: '',
    email: '',
    password: '',
    confirmedPassword: '',
  },
  errorMessage: null,
  loadingMessage: LOAD_MESSAGE.NONE,
}

const VALIDATE_MESSAGE = {
  NAME: 'Nome inválido',
  EMAIL: 'Email inválido',
  PASSWORD: 'Senha inválido',
  CONFIRMED_PASSWORD: 'Confirmação de Senha inválido',
  PASSWORD_NOT_EQUAL: 'Senha e confirmação de senha não são iguais',
}

export default function useSignup() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    const throwErrorOnForm = formFieldName =>
      setState(prevState => ({ ...prevState, errorMessage: VALIDATE_MESSAGE[formFieldName] }))

    const isNullOrBlank = string => !string || !string.trim()

    const passwordIsEqual = ({ password, confirmedPassword }) => password === confirmedPassword

    const formFieldsAreValid = formFields => {
      let formFieldsNames = Object.keys(formFields)
      let isValid = formFieldsNames.every(formFieldName => {
        if (isNullOrBlank(formFields[formFieldName])) {
          if (formFieldName === 'confirmedPassword') throwErrorOnForm('CONFIRMED_PASSWORD')
          else throwErrorOnForm(formFieldName.toUpperCase())
          return false
        }
        return true
      })

      if (!passwordIsEqual(formFields) && isValid) {
        throwErrorOnForm('PASSWORD_NOT_EQUAL')
        isValid = false
      }

      return isValid
    }

    return {
      // Actions
      requestUserRegister({ name, email, password }) {
        UserHttp.registerUser({ name, email, password })
          .then(() => {
            setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SUCCESS }))
          })
          .catch(error =>
            setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) })),
          )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      // Events
      onInputChange(name, value) {
        setState(prevState => {
          prevState.formFields[name] = value
          return { ...prevState }
        })
      },

      onSalvarClicked() {
        if (
          formFieldsAreValid(state.formFields) &&
          passwordIsEqual(state.formFields.password, state.formFields.confirmedPassword)
        )
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.REGISTERING }))
      },
    }
  }, [])

  return { state, localDispatch }
}
